<div class="grid-section">
  <div class="toolbar">
    <dx-button icon="refresh" text="Osvježi" type="default" (onClick)="onRefreshClick()">
    </dx-button>
  </div>

  <dx-data-grid 
    #ipGrid 
    id="ipGrid" 
    keyExpr="id" 
    [dataSource]="gridData" 
    (onRowPrepared)="onRowPrepared($event)"
    [showBorders]="true"
    [allowColumnResizing]="true"
    [showColumnLines]="true"
    [showRowLines]="true"
    [hoverStateEnabled]="true"
    [filterRow]="{ visible: true }"
    [searchPanel]="{ visible: true }"
    [paging]="{ pageSize: 50 }"
    [pager]="{
        visible: true,
        showPageSizeSelector: true,
        allowedPageSizes: [10, 20, 50, 100],
        showInfo: true,
        showNavigationButtons: true
    }"
    [rowAlternationEnabled]="true"
    [scrolling]="{ mode: 'virtual' }"
    [loadPanel]="{ enabled: true }">

    <!-- Warning icon column with proper template binding -->
    <dxi-column 
        caption=" " 
        [width]="40"
        cellTemplate="warningTemplate">
    </dxi-column>

    <dxi-column 
      dataField="username" 
      caption="Korisnik" 
      [minWidth]="150"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>

    <dxi-column 
      dataField="ip" 
      caption="IP" 
      [minWidth]="120"
      [allowFiltering]="true"
      [allowSearch]="true">
    </dxi-column>

    <dxi-column 
      dataField="date" 
      caption="Datum" 
      [minWidth]="150"
      dataType="date"
      format="dd.MM.yyyy HH:mm"
      [allowFiltering]="true">
    </dxi-column>

    <!-- Fixed template syntax -->
    <div *dxTemplate="let cell of 'warningTemplate'; let data = data">
        <i *ngIf="usersWithMultipleIPs.has(cell.data?.username)" 
           class="fas fa-exclamation-triangle" 
           style="color: #e74c3c;"
           [attr.title]="'Korisnik se prijavio s više IP adresa'">
        </i>
    </div>

    <dxo-scrolling mode="virtual"></dxo-scrolling>
    <dxo-sorting mode="multiple"></dxo-sorting>
  </dx-data-grid>
</div>

<dx-load-panel
  [position]="loadPanelPosition"
  [visible]="loading"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  shadingColor="rgba(0, 0, 0, 0.4)">
</dx-load-panel>